function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameHammerMobileTemplate = require('./game-hammer-mobile.template');

/**
 Utility to allow users to resize and move gameboard on a mobile device (replaces gameBoardSizer)
 Resizing and moving apply to a DOM element with id "gameboard" by default unless otherwise specified in attachEvents
*/

/*  fixHammerjsDeltaIssue: null,
  lastEvent: null,
  element: null,

  pinchZoomOrigin: {x: undefined, y: undefined},

  originalSize: {
    width: 2550,
    height: 1650
  },


  current: {
    x: 0,
    y: 0,
    z: 1,           //This is the scale factor
    width: 2550,
    height: 1650,
  },

*/
var GameHammerMobile = /*#__PURE__*/function () {
  function GameHammerMobile(app, mod) {
    _classCallCheck(this, GameHammerMobile);
    this.app = app;
    this.mod = mod;
    this.fixHammerjsDeltaIssue = null;
    this.lastEvent = null;
    this.element = null;
    this.pinchZoomOrigin = {
      x: undefined,
      y: undefined
    };
    this.originalSize = null;
    this.last = {
      x: 0,
      y: 0,
      z: 1
    };
    this.current = JSON.parse(JSON.stringify(this.last));
    this.debug = true;
    this.rendered = false;
    this.rightJustify = false;
  }
  return _createClass(GameHammerMobile, [{
    key: "render",
    value: function render() {
      var _this = this;
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.gameboard';
      var min_width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var min_height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      this.element = document.querySelector(target);
      if (!this.element) {
        console.error(target + ' does not exist for gameMobileHammer');
        return;
      }
      if (!this.rendered) {
        this.app.connection.on('browser-fullscreen-toggle', function () {
          setTimeout(function () {
            _this.render(target, min_width, min_height);
          }, 25);
        });
        this.rendered = true;
        screen.orientation.addEventListener('change', function (event) {
          var type = event.target.type;
          var angle = event.target.angle;
          console.log("ScreenOrientation change: ".concat(type, ", ").concat(angle, " degrees."));
          setTimeout(function () {
            _this.render(target, min_width, min_height);
          }, 25);
        });
      }
      this.element.removeAttribute('style');
      var boardWidth = parseInt(window.getComputedStyle(this.element).width);
      var boardHeight = parseInt(window.getComputedStyle(this.element).height);
      if (this.debug) {
        console.log('Basic gameboard size:', boardWidth, boardHeight);
      }
      if (window.getComputedStyle(this.element).boxSizing == 'content-box') {
        boardWidth += parseInt(window.getComputedStyle(this.element).paddingLeft) + parseInt(window.getComputedStyle(this.element).paddingRight);
        boardHeight += parseInt(window.getComputedStyle(this.element).paddingTop) + parseInt(window.getComputedStyle(this.element).paddingBottom);
      }
      if (this.debug) {
        console.log('With padding included:', boardWidth, boardHeight);
      }
      boardWidth += parseInt(window.getComputedStyle(this.element).marginLeft) + parseInt(window.getComputedStyle(this.element).marginRight);
      boardHeight += parseInt(window.getComputedStyle(this.element).marginTop) + parseInt(window.getComputedStyle(this.element).marginBottom);
      if (this.debug) {
        console.log('and with margins:', boardWidth, boardHeight);
      }
      this.originalSize = {
        width: boardWidth,
        height: boardHeight
      };
      this.element.style.position = 'absolute';
      var fit_width = window.innerWidth;
      var fit_height = window.innerHeight;
      if (this.debug) {
        console.log('screensize: ', fit_width, fit_height);
      }
      var scale = Math.floor(100 * Math.min(fit_width / boardWidth, fit_height / boardHeight)) / 100;
      console.log(this.originalSize);
      this.pinchZoomOrigin = this.getRelativePosition(this.element, {
        x: 0,
        y: 0
      }, this.originalSize, 1);
      var d = this.scaleFrom(this.pinchZoomOrigin, 1, scale);
      console.log(d);
      this.current.x = d.x;
      this.current.y = d.y;
      this.current.z = d.z;
      this.last = JSON.parse(JSON.stringify(this.current));
      this.update();
      if (min_width) {
        //Square boards
        min_height = min_height || min_width;
        if (min_width > window.innerWidth || min_height > window.innerHeight) {
          this.min_width = min_width;
          this.min_height = min_height;
          if (!document.getElementById('game_board_size_toggle')) {
            this.app.browser.addElementToDom(GameHammerMobileTemplate());
          }
        }
        this.alternateEvents(target);
      } else {
        this.attachEvents(target);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(target) {
      if (!this.element) {
        console.error('Invalid selector for gameHammerMobile: ', target, 'does not exist in DOM');
        return;
      }
      try {
        //Create hammer (HammerJS included in index.html script)
        var hammertime = new Hammer(this.element, {});
        hammertime.get('pinch').set({
          enable: true
        });
        hammertime.get('pan').set({
          threshold: 0
        });
        var hammer_self = this;

        //Dragging object
        hammertime.on('pan', function (e) {
          hammer_self.element.style.transition = 'unset';
          if (hammer_self.lastEvent !== 'pan') {
            hammer_self.fixHammerjsDeltaIssue = {
              x: e.deltaX,
              y: e.deltaY
            };
          }
          hammer_self.current.x = hammer_self.last.x + e.deltaX - hammer_self.fixHammerjsDeltaIssue.x;
          hammer_self.current.y = hammer_self.last.y + e.deltaY - hammer_self.fixHammerjsDeltaIssue.y;
          hammer_self.lastEvent = 'pan';
          hammer_self.update();
        });
        hammertime.on('panend', function (e) {
          hammer_self.last.x = hammer_self.current.x;
          hammer_self.last.y = hammer_self.current.y;
          hammer_self.lastEvent = 'panend';
          hammer_self.element.style.transition = '';
        });

        //Pinch scaling object
        hammertime.on('pinch', function (e) {
          console.log(e.scale);
          var d = hammer_self.scaleFrom(hammer_self.pinchZoomOrigin, hammer_self.last.z, hammer_self.last.z * e.scale);
          hammer_self.current.x = (d.x + hammer_self.last.x + e.deltaX) * e.scale;
          hammer_self.current.y = (d.y + hammer_self.last.y + e.deltaY) * e.scale;
          hammer_self.current.z = d.z;
          hammer_self.lastEvent = 'pinch';
          hammer_self.update();
        });
        hammertime.on('pinchstart', function (e) {
          hammer_self.pinchZoomOrigin = hammer_self.getRelativePosition(hammer_self.element, {
            x: e.center.x,
            y: e.center.y
          }, hammer_self.originalSize, hammer_self.current.z);
          hammer_self.lastEvent = 'pinchstart';
        });
        hammertime.on('pinchend', function (e) {
          hammer_self.last.x = hammer_self.current.x;
          hammer_self.last.y = hammer_self.current.y;
          hammer_self.last.z = hammer_self.current.z;
          hammer_self.lastEvent = 'pinchend';
        });
      } catch (err) {
        console.error('Error: ' + err);
      }
    }
  }, {
    key: "alternateEvents",
    value: function alternateEvents(target) {
      var _this2 = this;
      var toggle = document.getElementById('game_board_size_toggle');
      if (toggle) {
        toggle.onclick = function (e) {
          var icon = e.currentTarget.querySelector('i');
          var fit_width, fit_height;
          if (icon.classList.contains('fa-minimize')) {
            fit_width = window.innerWidth;
            fit_height = window.innerHeight;
          } else {
            fit_width = Math.max(window.innerWidth, _this2.min_width);
            fit_height = Math.max(window.innerHeight, _this2.min_height);
          }
          icon.classList.toggle('fa-minimize');
          icon.classList.toggle('fa-maximize');
          _this2.element.style.left = '';
          _this2.element.style.top = '';
          var scale = Math.floor(100 * Math.min(fit_width / _this2.originalSize.width, fit_height / _this2.originalSize.height)) / 100;
          _this2.pinchZoomOrigin = _this2.getRelativePosition(_this2.element, {
            x: 0,
            y: 0
          }, _this2.originalSize, 1);
          var d = _this2.scaleFrom(_this2.pinchZoomOrigin, 1, scale);
          _this2.current.x = d.x;
          _this2.current.y = d.y;
          _this2.current.z = d.z;
          _this2.last = JSON.parse(JSON.stringify(_this2.current));
          _this2.update();
          _this2.makeDraggableBounded(target);
        };
      }
      this.makeDraggableBounded(target);
    }
  }, {
    key: "makeDraggableBounded",
    value: function makeDraggableBounded(target) {
      try {
        var element_to_move = document.querySelector(target);
        var mouse_down_left = 0;
        var mouse_down_top = 0;
        var mouse_current_left = 0;
        var mouse_current_top = 0;
        var element_start_left = 0;
        var element_start_top = 0;
        var element_width = element_to_move.getBoundingClientRect().width;
        var element_height = element_to_move.getBoundingClientRect().height;

        // Allow you to push the board off screen, but keep enough so you can grab it again

        var max_x, min_x, max_y, min_y;
        if (element_width >= window.innerWidth) {
          max_x = 0;
          min_x = window.innerWidth - element_width;
        } else {
          min_x = 0;
          max_x = window.innerWidth - element_width;
        }
        if (element_height >= window.innerHeight) {
          max_y = 0;
          min_y = window.innerHeight - element_height;
        } else {
          min_y = 0;
          max_y = window.innerHeight - element_height;
        }
        if (this.debug) {
          console.log('Set dragging boundaries: ', min_x, min_y, max_x, max_y);
        }
        if (this.rightJustify) {
          element_to_move.style.left = max_x + 'px';
        }
        element_to_move.ontouchstart = function (e) {
          var _e$currentTarget;
          e = e || window.event;
          if (!((_e$currentTarget = e.currentTarget) !== null && _e$currentTarget !== void 0 && _e$currentTarget.id) || !target.includes(e.currentTarget.id)) {
            console.warn(target);
            document.ontouchend = null;
            document.ontouchmove = null;
            return;
          }
          element_to_move.style.transition = 'unset';
          var rect = element_to_move.getBoundingClientRect();
          element_start_left = rect.left;
          element_start_top = rect.top;
          mouse_down_left = e.targetTouches[0] ? e.targetTouches[0].pageX : e.changedTouches[e.changedTouches.length - 1].pageX;
          mouse_down_top = e.targetTouches[0] ? event.targetTouches[0].pageY : e.changedTouches[e.changedTouches.length - 1].pageY;
          mouse_current_left = mouse_down_left;
          mouse_current_top = mouse_down_top;
          document.ontouchend = /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    document.ontouchend = null;
                    document.ontouchmove = null;
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }();
          document.ontouchmove = function (e) {
            e = e || window.event;
            //e.preventDefault();

            mouse_current_left = e.targetTouches[0] ? e.targetTouches[0].pageX : e.changedTouches[e.changedTouches.length - 1].pageX;
            mouse_current_top = e.targetTouches[0] ? event.targetTouches[0].pageY : e.changedTouches[e.changedTouches.length - 1].pageY;
            var adjustmentX = mouse_current_left - mouse_down_left;
            var adjustmentY = mouse_current_top - mouse_down_top;
            var newPosX = element_start_left + adjustmentX;
            var newPosY = element_start_top + adjustmentY;
            newPosX = Math.max(min_x, Math.min(newPosX, max_x));
            newPosY = Math.max(min_y, Math.min(newPosY, max_y));

            // set the element's new position:
            element_to_move.style.left = newPosX + 'px';
            element_to_move.style.top = newPosY + 'px';
            element_to_move.style.bottom = 'unset';
            element_to_move.style.right = 'unset';
            element_to_move.style.marginTop = 'unset';
            element_to_move.style.marginLeft = 'unset';
          };
        };
      } catch (err) {
        console.error('error: ' + err);
      }
    }
  }, {
    key: "update",
    value: function update() {
      this.current.height = this.originalSize.height * this.current.z;
      this.current.width = this.originalSize.width * this.current.z;
      this.element.style.transform = "translate3d(".concat(this.current.x, "px, ").concat(this.current.y, "px, 0) scale(").concat(this.current.z, ")");
    }
  }, {
    key: "getRelativePosition",
    value: function getRelativePosition(element, point, originalSize, scale) {
      var domCoords = this.getCoords(element);
      var elementX = point.x - domCoords.x;
      var elementY = point.y - domCoords.y;
      var relativeX = elementX / (originalSize.width * scale / 2) - 1;
      var relativeY = elementY / (originalSize.height * scale / 2) - 1;
      return {
        x: relativeX,
        y: relativeY
      };
    }
  }, {
    key: "getCoords",
    value: function getCoords(elem) {
      var box = elem.getBoundingClientRect();
      var body = document.body;
      var docEl = document.documentElement;
      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
      var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
      var clientTop = docEl.clientTop || body.clientTop || 0;
      var clientLeft = docEl.clientLeft || body.clientLeft || 0;
      var top = box.top + scrollTop - clientTop;
      var left = box.left + scrollLeft - clientLeft;
      return {
        x: Math.round(left),
        y: Math.round(top)
      };
    }
  }, {
    key: "scaleFrom",
    value: function scaleFrom(zoomOrigin, currentScale, newScale) {
      var currentShift = this.getCoordinateShiftDueToScale(this.originalSize, currentScale);
      var newShift = this.getCoordinateShiftDueToScale(this.originalSize, newScale);
      //game_mod.updateLog(`Current (${currentScale}):${currentShift.x}, ${currentShift.y}; New (${newScale}):${newShift.x}, ${newShift.y} `);

      return {
        x: zoomOrigin.x * (currentShift.x - newShift.x),
        y: zoomOrigin.y * (currentShift.y - newShift.y),
        z: newScale
      };
    }
  }, {
    key: "getCoordinateShiftDueToScale",
    value: function getCoordinateShiftDueToScale(size, scale) {
      var newWidth = scale * size.width;
      var newHeight = scale * size.height;
      var dx = (newWidth - size.width) / 2;
      var dy = (newHeight - size.height) / 2;
      return {
        x: dx,
        y: dy
      };
    }
  }]);
}();
module.exports = GameHammerMobile;